import { buildShip } from "./ship.js";
import { migrateScoreCalibration } from "./progress.js";
import { enhanceRoad } from "./roads.js";
import { installRuntime } from "./runtime.js";

migrateScoreCalibration();

window.__orbitrushBuildShip = buildShip;
window.__orbitrushEnhanceRoad = enhanceRoad;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", installRuntime, { once: true });
} else {
  installRuntime();
}
